// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"abd2cd85","538":"2f108621"}[chunkId] + ".chunk.css";
};